import Tone from 'tone';
import Effects from 'effects/Effects.js';
import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';

class BitCrusher extends Effects.Effect {
    constructor(sequencerEngine) {
        super("Bit Crusher", () => new Tone.BitCrusher(8), sequencerEngine);
        this.bitsParameter = new AbstractAudioParamParameter(
            'Bits', this.effectNode, (o, x) => o.bits = x,
            {
                min: 1,
                max: 8,
                unit: '',
                defaultValue: 8
            });
        this.registerParameter(this.bitsParameter);
        this.updateInitialValues();
    }

    getJson(isPreset) {
        let json = super.getJson();
        json.bits = this.bitsParameter.get();
        json.name = this.name;
        return this.saveParameterToJson(json, 'bitsParameter', this.bitsParameter, isPreset);
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        this.effectNode.bits = json.bits;
        this.effectNode.wet.value = json.wet;

        if (json.enabled) {
            this.enable(true);
        }

        return {
            ... bulk,
            ... this.loadParameterFromJson(json, 'bitsParameter', this.bitsParameter, isCopy)
        };
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new BitCrusher(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default BitCrusher;
